import { ACDLRoute, BaseRouteConfig } from './BaseRoute';

export class DatasetsPath extends BaseRouteConfig {
  public readonly Index = 'datasets';

  public readonly List = new ACDLRoute<{ workspaceId: string }>(`${this.Path}/list`);

  public readonly Create = new ACDLRoute<{ workspaceId: string; datasetDraftId: string }>(`${this.Path}/create/:datasetDraftId?`);

  public readonly Details = {
    Path: `${this.Path}/:datasetId`,
    Paths: new ACDLRoute<{ workspaceId: string; datasetId: string; tab: string }>(`${this.Path}/:datasetId/:tab`),
    Images: new ACDLRoute<{ workspaceId: string; datasetId: string; page?: number }>(`${this.Path}/:datasetId/images/:page?`),
    Preview: new ACDLRoute<{ workspaceId: string; datasetId: string; imageId: string }>(`${this.Path}/:datasetId/preview/:imageId`),
    Projects: new ACDLRoute<{ workspaceId: string; datasetId: string }>(`${this.Path}/:datasetId/projects`),
  };
}
